import React from "react";
import { useContent } from "../context/ContentProvider";

const About: React.FC = () => {
  const { content } = useContent();

  return (
    <div style={{ backgroundColor: "var(--hotel-background-color)" }}>
      <div
        className="relative w-full h-[500px] bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: "url('/props.webp')" }}
        aria-label="About"
      >
        <div className="absolute inset-0 bg-black/40 pointer-events-none" />
        <div
          className="relative z-10 text-white text-4xl md:text-6xl font-bold text-center"
          style={{
            fontFamily: "var(--hotel-heading-font-family)",
            color: "var(--hotel-text-color)",
            textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
          }}
        >
          {content.aboutTitle || "À PROPOS"}
        </div>
      </div>
      <div
        className="min-h-screen py-16 px-6"
        style={{
          backgroundColor: "var(--hotel-card-background-color)",
          color: "var(--hotel-text-color)",
        }}
      >
        <div className="max-w-4xl mx-auto">
          {/* Decorative line */}
          <div className="flex justify-center mb-8">
            <div
              className="w-16 h-px"
              style={{ backgroundColor: "var(--hotel-primary-color)" }}
            ></div>
          </div>

          {/* Title */}
          <h1
            className="text-2xl md:text-3xl font-bold text-center mb-12 uppercase tracking-wide"
            style={{
              fontFamily: "var(--hotel-heading-font-family)",
              color: "var(--hotel-primary-color)",
            }}
          >
            {content.aboutTitle || "À PROPOS"}
          </h1>

          {/* Content */}
          <div
            className="prose prose-lg max-w-none"
            style={{
              fontFamily: "var(--hotel-body-font-family)",
              color: "var(--hotel-text-color)",
            }}
          >
            <div
              className="text-base md:text-lg leading-relaxed space-y-6"
              style={{
                fontFamily: "var(--hotel-body-font-family)",
                color: "var(--hotel-text-color)",
                lineHeight: "1.7",
              }}
            >
              {content.aboutContent ? (
                <div
                  className="whitespace-pre-line"
                  dangerouslySetInnerHTML={{
                    __html: content.aboutContent
                      .replace(/\n\n/g, "</p><p>")
                      .replace(/\n/g, "<br>"),
                  }}
                />
              ) : (
                <div className="space-y-8">
                  <p className="text-lg leading-relaxed">
                    Bienvenue à l'Hôtel Adriatica, votre oasis de tranquillité à
                    Champel, Genève, où chaque moment est une invitation à la
                    détente et à l'exploration.
                  </p>

                  <p className="text-base leading-relaxed">
                    Idéalement situé à proximité de l'Hôpital Cantonal de Genève
                    (HUG), du Centre Médical Universitaire (CMU) et d'autres
                    institutions prestigieuses, notre hôtel offre un refuge
                    confortable pour les voyageurs exigeants.
                  </p>

                  <p className="text-base leading-relaxed">
                    Dès votre arrivée, vous serez accueilli dans nos chambres
                    spacieuses, allant de 25 à 35 mètres carrés, offrant un
                    espace généreux pour vous détendre après une journée bien
                    remplie. Élégamment décorées et équipées de tout le confort
                    moderne, nos chambres sont conçues pour votre confort
                    absolu.
                  </p>

                  <p className="text-base leading-relaxed">
                    Pour rendre votre séjour encore plus agréable, nous
                    proposons une gamme de services haut de gamme, notamment un
                    petit espace fitness pour maintenir votre routine
                    d'exercice, un parking privé pour votre tranquillité
                    d'esprit, et un bar chaleureux où vous pourrez savourer des
                    boissons rafraîchissantes.
                  </p>

                  <p className="text-base leading-relaxed">
                    Commencez votre journée du bon pied en dégustant un
                    délicieux petit-déjeuner dans notre salle de petit-déjeuner
                    confortable, ou en le commandant en chambre pour un réveil
                    en douceur.
                  </p>

                  <p className="text-base leading-relaxed">
                    Pour explorer les magnifiques environs de Genève, nous
                    proposons également un service de location de vélos, vous
                    permettant de découvrir la ville à votre rythme et de
                    profiter de ses nombreux sentiers et pistes cyclables.
                  </p>

                  <p className="text-base leading-relaxed font-medium">
                    Que vous soyez à Genève pour affaires ou pour le plaisir,
                    notre équipe dévouée est à votre disposition pour rendre
                    votre séjour inoubliable. Nous sommes impatients de vous
                    accueillir à l'Hôtel Adriatica et de vous offrir une
                    expérience véritablement exceptionnelle à Genève.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
